import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Product } from '../../../models';
import { LibCoreLayoutModule } from '../../core-layout';
import { PipesModule } from '../../../pipes';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

export interface ProductPromotionDialogComponentData {
  product: Product;
  currency: string;
}

@Component({
  selector: 'lib-product-promotion-dialog',
  templateUrl: './product-promotion-dialog.component.html',
  styleUrls: ['./product-promotion-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LibCoreLayoutModule,
    PipesModule,
    TranslateModule,
    // material design
    MatButtonModule,
  ],
})
export class ProductPromotionDialogComponent {
  public product: Product;
  public discountText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: ProductPromotionDialogComponentData,
    private dialogRef: MatDialogRef<ProductPromotionDialogComponent>
  ) {
    this.product = this.data?.product;

    this.discountText = `- ${this.product?.promotion?.amount} ${
      this.product?.promotion?.percentage ? '%' : this.data?.currency
    }`;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
